<template>
  <orders-view
    class="content"
    :override-list-configuration="finalListConfiguration"
    @crud-list:items-updated="updateItemsCount" />
  <div v-if="itemsCount > 0" class="see-all text-center">
    <saffron-link :to="linkTo">{{ t("justopp.orders.seeOrdersCta") }}</saffron-link>
  </div>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations";
import OrdersView from "@/client/applications/justopp/views/Orders";

export default {
  components: { OrdersView },
  props: {
    vendorId: {
      type: Number,
      default: null,
    },
    linkTo: {
      type: Object,
      default: () => ({
        name: "user-dashboard-bids",
      }),
    },
  },
  setup(props) {
    let { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations(props);
    return { asyncOps, asyncOpsReady, asyncStatus };
  },
  data: function () {
    return {
      itemsCount: 0,
      listConfiguration: {
        showIdField: false,
        fields: {
          status: {
            itemKey: "status",
            label: "ecommerce.order.fields.status",
            orderable: false,
          },
          updatedAt: {
            itemKey: "updatedAt",
            label: "ecommerce.order.fields.updatedAt",
            orderable: false,
          },
          totalWithTax: {
            label: "ecommerce.order.fields.totalWithTax",
            orderable: false,
          },
          vendors: {
            label: "ecommerce.order.fields.vendors",
            orderable: false,
          },
        },
        actions: false,
        paginationConfig: {
          start: 0,
          limit: 3,
          show: false,
        },
      },
    };
  },
  computed: {
    finalListConfiguration() {
      const listConfiguration = { ...this.listConfiguration };

      if (this.vendorId) {
        listConfiguration.constantFilters = { vendorId: this.vendorId };

        delete listConfiguration.fields.vendors;
        listConfiguration.fields.buyer = {
          label: "ecommerce.order.fields.buyer",
          orderable: false,
        };
      }

      return listConfiguration;
    },
  },
  methods: {
    updateItemsCount(items) {
      if (items) {
        this.itemsCount = items.length;
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
